module.exports = __webpack_public_path__ + "static/media/certificado.dde817c8.png";